import React, { useEffect, useState } from 'react';
import {
  FaFile,
  FaFileAlt,
  FaFilePdf,
  FaFileAudio,
  FaImage,
  FaVideo,
  FaDownload,
} from 'react-icons/fa';
import { TiArrowForward } from 'react-icons/ti';
import Linkify from 'react-linkify';
import ActionsMessage from '../actionsmessage';
import ViewPoll from '../viewPoll';
import {
  AttachmentContainer,
  AttachmentFile,
  Balloon,
  BalloonActions,
  BalloonDate,
  BalloonInfo,
  ForwardText,
  RepliedMessage,
  MessageLink,
  MessageText,
  DownloadButton,
} from './styles';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import DoneIcon from '@material-ui/icons/Done';
import { getStringDate, resolveMessage } from '../../utils';
import LoadingIcon from '../../assets/images/loading.gif';
import { Image } from './image';
import { EncryptedMedia } from './EncryptedMedia';

import { useIntl } from 'react-intl';
import { getE2EEncryptionEnabledFlag } from '../../storage/index';
import CircularProgress from '@material-ui/core/CircularProgress';
import { RsaDecryptor, DecryptAttachmentBrowser } from '../../services/e2ee';

const BalloonComponent = ({
  message,
  conversationId,
  isDeleted,
  userGuid,
  formatedDate,
  urlDowload,
  setAttSeleted,
  setSelectedMessage,
  setSelectedMessageForward,
  text,
  setOpen,
  scrollTo,
  decryptAndCreateBlobUrl,
}) => {
  const [loading, setLoading] = useState(false);
  const [downloadingGuid, setDownloadingGuid] = useState(null);
  const [activeXhr, setActiveXhr] = useState(null);
  const [downloadProgress, setDownloadProgress] = useState(0);
  const [isHoveredDownload, setIsHoveredDownload] = useState(false);

  const intl = useIntl();
  const isE2EEnabled = getE2EEncryptionEnabledFlag();

  const handleDownloadClick = async (e, att) => {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }

    // If already downloading, clicking again cancels the download
    if (activeXhr && downloadingGuid === att.Guid) {
      console.log('[Download] Canceling download...');
      activeXhr.abort();
      setActiveXhr(null);
      setDownloadingGuid(null);
      setDownloadProgress(0);
      return;
    }

    setDownloadingGuid(att.Guid);
    setDownloadProgress(0);

    const targetUrl = `${urlDowload}/${att.Guid}`;
    const totalBytes = (att.Size || 0) * 1024; // Convert KB from database to Bytes
    const xhr = new XMLHttpRequest();
    xhr.open('GET', targetUrl, true);
    xhr.responseType = 'arraybuffer';
    setActiveXhr(xhr);

    xhr.onprogress = (event) => {
      let percent = 0;
      if (event.lengthComputable) {
        percent = Math.round((event.loaded / event.total) * 100);
      } else if (totalBytes > 0) {
        percent = Math.round((event.loaded / totalBytes) * 100);
      }

      if (percent > 0) {
        setDownloadProgress(Math.min(percent, 99)); // Limit to 99% until decryption finishes
      }
    };

    xhr.onload = async () => {
      if (xhr.status === 200) {
        try {
          const arrayBuffer = xhr.response;
          const mimeType = getMimeType(att.AttachmentType);

          let finalBlob;
          if (isE2EEnabled === 'true') {
            const decryptedKey = await RsaDecryptor(att.EncryptionKey);
            const decryptedIv = await RsaDecryptor(att.Iv);
            const decryptedBytes = await DecryptAttachmentBrowser(
              arrayBuffer,
              decryptedIv,
              decryptedKey
            );
            if (!decryptedBytes || decryptedBytes.length === 0) {
              throw new Error('Decrypted bytes are empty');
            }
            finalBlob = new Blob([decryptedBytes], { type: mimeType });
          } else {
            finalBlob = new Blob([arrayBuffer], { type: mimeType });
          }

          const blobUrl = URL.createObjectURL(finalBlob);
          const a = document.createElement('a');
          a.href = blobUrl;
          a.download = att.Name;
          a.click();
          URL.revokeObjectURL(blobUrl);
        } catch (err) {
          console.error('[Download] Decryption/Save error:', err);
        }
      }
      setActiveXhr(null);
      setDownloadingGuid(null);
      setDownloadProgress(0);
    };

    xhr.onerror = () => {
      console.error('[Download] Network error');
      setActiveXhr(null);
      setDownloadingGuid(null);
      setDownloadProgress(0);
    };

    xhr.onabort = () => {
      setActiveXhr(null);
      setDownloadingGuid(null);
      setDownloadProgress(0);
    };

    xhr.send();
  };

  useEffect(() => {
    if (message) {
      if (message.IsForward) {
      }
    }
  }, [message]);

  const onLoad = () => {
    console.log('====================================');
    console.log('loading');
    console.log('====================================');
  };

  const onLoaded = () => {
    console.log('====================================');
    console.log('load');
    console.log('====================================');
  };

  const getMimeType = (attachmentType) => {
    switch (attachmentType) {
      case 0:
        return 'image/png';
      case 1:
        return 'image/jpeg'; // or detect exact format if needed
      case 10:
        return 'application/pdf';
      case 11:
        return 'text/plain';
      case 100:
        return 'application/octet-stream'; // fallback type for unknowns
      case 20:
        return 'video/mp4'; // or whatever format your videos are in
      default:
        return 'application/octet-stream'; // safe default
    }
  };
  const resolvedRef = resolveMessage(message);

  return (
    <Balloon
      id={message.Guid}
      my={message.Sender?.StaffGuid === userGuid}
      isDeleted={message.isDeleted}
      isForward={message.IsForward === true}
      isToday={getStringDate(formatedDate).length === 5}
      style={{
        whiteSpace: 'break-spaces',
      }}
    >
      {conversationId.isGroup && (
        <div style={{ fontSize: 12, display: 'block' }}>
          {message.Sender?.StaffGuid !== userGuid
            ? message.Sender.Name + ':'
            : ''}
        </div>
      )}
      {!isDeleted && message.IsForward && (
        <ForwardText>
          <div>
            <TiArrowForward />
            {intl.formatMessage({ id: 'ForwardedFrom' })}
          </div>
          <span style={{ marginLeft: 13 }}>
            {message.ReferencedMessage?.Sender?.Name}
          </span>
        </ForwardText>
      )}

      {!isDeleted && message.IsReply && message.ReferencedMessage && (
        <RepliedMessage
          onClick={() => scrollTo(message.ReferencedMessage.Guid)}
        >
          {message.ReferencedMessage.Attachments.length > 0 && (
            <AttachmentContainer
              onClick={() => scrollTo(message.ReferencedMessage.Guid)}
            >
              {message.ReferencedMessage.Attachments.map((att, key) => {
                // Check if E2E is enabled for the replied attachment
                if (isE2EEnabled === 'true') {
                  const handleAttachmentClick = async (e) => {
                    if (e) e.stopPropagation();
                    if (downloadingGuid === att.Guid) return; // Prevent double-clicking
                    setDownloadingGuid(att.Guid); // Start loading
                    try {
                      const mimeType = getMimeType(att.AttachmentType);
                      await decryptAndCreateBlobUrl(
                        `${urlDowload}/${att.Guid}`,
                        att.EncryptionKey,
                        att.Iv,
                        mimeType,
                        att.Name
                      );
                    } finally {
                      setDownloadingGuid(null); // Stop loading
                    }
                  };

                  return (
                    <AttachmentFile key={key}>
                      {/* download button */}
                      <DownloadButton
                        onClick={(e) => handleDownloadClick(e, att)}
                        onMouseEnter={() => setIsHoveredDownload(true)}
                        onMouseLeave={() => setIsHoveredDownload(false)}
                      >
                        {downloadingGuid === att.Guid ? (
                          isHoveredDownload ? (
                            <span
                              style={{ fontSize: '10px', fontWeight: 'bold' }}
                            >
                              X
                            </span>
                          ) : (
                            <CircularProgress
                              variant={
                                downloadProgress > 0
                                  ? 'determinate'
                                  : 'indeterminate'
                              }
                              value={
                                downloadProgress > 0
                                  ? downloadProgress
                                  : undefined
                              }
                              size={16}
                              color="secondary"
                            />
                          )
                        ) : (
                          <FaDownload size={13} />
                        )}
                      </DownloadButton>

                      {att &&
                        (att.AttachmentType === 0 ||
                          att.AttachmentType === 1) && (
                          <EncryptedMedia
                            att={att}
                            setAttSeleted={setAttSeleted}
                            urlDowload={urlDowload}
                          />
                        )}
                      {att && att.AttachmentType === 20 && (
                        <EncryptedMedia
                          att={att}
                          setAttSeleted={setAttSeleted}
                          urlDowload={urlDowload}
                        />
                      )}

                      {att && att.AttachmentType === 10 && (
                        <button
                          onClick={handleAttachmentClick}
                          disabled={downloadingGuid === att.Guid}
                        >
                          <FaFilePdf size={30} color="red" />
                          <p title={att.Name}>{att.Name}</p>
                        </button>
                      )}

                      {att && att.AttachmentType === 11 && (
                        <button
                          onClick={handleAttachmentClick}
                          disabled={downloadingGuid === att.Guid}
                        >
                          <FaFileAlt size={30} color="#333" />
                          <p title={att.Name}>{att.Name}</p>
                        </button>
                      )}

                      {att &&
                        att.AttachmentType !== 0 &&
                        att.AttachmentType !== 1 &&
                        att.AttachmentType !== 10 &&
                        att.AttachmentType !== 11 &&
                        att.AttachmentType !== 20 &&
                        att.AttachmentType !== 100 && (
                          <button
                            onClick={handleAttachmentClick}
                            disabled={downloadingGuid === att.Guid}
                          >
                            <FaFileAlt size={30} color="#666" />
                            <p title={att.Name}>{att.Name}</p>
                          </button>
                        )}

                      {att && att.AttachmentType === 100 && (
                        <button
                          onClick={handleAttachmentClick}
                          disabled={downloadingGuid === att.Guid}
                        >
                          <FaFile size={30} color="#333" />
                          <p title={att.Name}>{att.Name}</p>
                        </button>
                      )}
                    </AttachmentFile>
                  );
                }

                // Fallback for when E2E is disabled (Original Code)
                return (
                  <AttachmentFile key={key}>
                    {att &&
                      (att.AttachmentType === 0 ||
                        att.AttachmentType === 1) && (
                        <Image
                          att={att}
                          urlDowload={urlDowload}
                          setAttSeleted={setAttSeleted}
                        />
                      )}
                    {att && att.AttachmentType === 20 && (
                      <video controls height="250" width="250">
                        <source src={`${urlDowload}/${att.Guid}`} />
                      </video>
                    )}

                    {att && att.AttachmentType === 10 && (
                      <a href={`${urlDowload}/${att.Guid}`} download>
                        <FaFilePdf size={30} color="red" />
                      </a>
                    )}

                    {att && att.AttachmentType === 11 && (
                      <a href={`${urlDowload}/${att.Guid}`} download>
                        <FaFileAlt size={30} color="#333" />
                      </a>
                    )}

                    {att &&
                      att.AttachmentType !== 0 &&
                      att.AttachmentType !== 1 &&
                      att.AttachmentType !== 10 &&
                      att.AttachmentType !== 11 &&
                      att.AttachmentType !== 20 &&
                      att.AttachmentType !== 100 && (
                        <a href={`${urlDowload}/${att.Guid}`} download>
                          <FaFileAlt size={30} color="#666" />
                        </a>
                      )}

                    {att && att.AttachmentType === 100 && (
                      <a href={`${urlDowload}/${att.Guid}`} download>
                        <FaFile size={30} color="#333" />
                      </a>
                    )}
                  </AttachmentFile>
                );
              })}
            </AttachmentContainer>
          )}
          {resolvedRef.IsHtmlMessage ? (
            <div
              dangerouslySetInnerHTML={{
                __html: resolvedRef.Message,
              }}
            />
          ) : (
            resolvedRef.Message
          )}
        </RepliedMessage>
      )}
      {message.Attachments.length > 0 && (
        <AttachmentContainer>
          {message.Attachments.map((att, key) => {
            if (isE2EEnabled === 'true') {
              const isEncrypted = att.EncryptionKey && att.Iv;
              const handleAttachmentClick = async (e) => {
                if (e) e.stopPropagation();
                setDownloadingGuid(att.Guid); // Start loading
                try {
                  const mimeType = getMimeType(att.AttachmentType);
                  await decryptAndCreateBlobUrl(
                    `${urlDowload}/${att.Guid}`,
                    att.EncryptionKey,
                    att.Iv,
                    mimeType,
                    att.Name
                  );
                } finally {
                  setDownloadingGuid(null); // Stop loading
                }
              };

              return (
                <React.Fragment key={key}>
                  <AttachmentFile key={key}>
                    <DownloadButton
                      onClick={(e) => handleDownloadClick(e, att)}
                      onMouseEnter={() => setIsHoveredDownload(true)}
                      onMouseLeave={() => setIsHoveredDownload(false)}
                    >
                      {downloadingGuid === att.Guid ? (
                        isHoveredDownload ? (
                          <span
                            style={{ fontSize: '10px', fontWeight: 'bold' }}
                          >
                            X
                          </span>
                        ) : (
                          <CircularProgress
                            variant={
                              downloadProgress > 0
                                ? 'determinate'
                                : 'indeterminate'
                            }
                            value={
                              downloadProgress > 0
                                ? downloadProgress
                                : undefined
                            }
                            size={16}
                            color="secondary"
                          />
                        )
                      ) : (
                        <FaDownload size={13} />
                      )}
                    </DownloadButton>

                    {att &&
                      (att.AttachmentType === 0 ||
                        att.AttachmentType === 1) && (
                        <EncryptedMedia
                          att={att}
                          setAttSeleted={setAttSeleted}
                          urlDowload={urlDowload}
                        />
                      )}
                    {att && att.AttachmentType === 20 && (
                      <EncryptedMedia
                        att={att}
                        setAttSeleted={setAttSeleted}
                        urlDowload={urlDowload}
                      />
                    )}

                    {att && att.AttachmentType === 10 && (
                      <button onClick={handleAttachmentClick}>
                        <FaFilePdf size={30} color="red" />
                        <p title={att.Name}>{att.Name}</p>
                      </button>
                    )}

                    {att && att.AttachmentType === 11 && (
                      <button onClick={handleAttachmentClick}>
                        <FaFileAlt size={30} color="#333" />
                        <p title={att.Name}>{att.Name}</p>
                      </button>
                    )}

                    {att &&
                      att.AttachmentType !== 0 &&
                      att.AttachmentType !== 1 &&
                      att.AttachmentType !== 10 &&
                      att.AttachmentType !== 11 &&
                      att.AttachmentType !== 20 &&
                      att.AttachmentType !== 100 && (
                        <button onClick={handleAttachmentClick}>
                          <FaFileAlt size={30} color="#666" />
                          <p title={att.Name}>{att.Name}</p>
                        </button>
                      )}

                    {att && att.AttachmentType === 100 && (
                      <button onClick={handleAttachmentClick}>
                        <FaFile size={30} color="#333" />
                        <p title={att.Name}>{att.Name}</p>
                      </button>
                    )}
                  </AttachmentFile>
                </React.Fragment>
              );
            } else {
              return (
                <React.Fragment key={key}>
                  <AttachmentFile key={key}>
                    <DownloadButton
                      onClick={(e) => handleDownloadClick(e, att)}
                      onMouseEnter={() => setIsHoveredDownload(true)}
                      onMouseLeave={() => setIsHoveredDownload(false)}
                    >
                      {downloadingGuid === att.Guid ? (
                        isHoveredDownload ? (
                          <span
                            style={{ fontSize: '10px', fontWeight: 'bold' }}
                          >
                            X
                          </span>
                        ) : (
                          <CircularProgress
                            variant={
                              downloadProgress > 0
                                ? 'determinate'
                                : 'indeterminate'
                            }
                            value={
                              downloadProgress > 0
                                ? downloadProgress
                                : undefined
                            }
                            size={16}
                            color="secondary"
                          />
                        )
                      ) : (
                        <FaDownload size={13} />
                      )}
                    </DownloadButton>

                    {att &&
                      (att.AttachmentType === 0 ||
                        att.AttachmentType === 1) && (
                        <Image
                          att={att}
                          urlDowload={urlDowload}
                          setAttSeleted={setAttSeleted}
                        />
                      )}
                    {att && att.AttachmentType === 20 && (
                      <video controls height="250" width="250">
                        <source src={`${urlDowload}/${att.Guid}`} />
                        <p title={att.Name}>{att.Name}</p>
                      </video>
                    )}
                    {att && att.AttachmentType === 10 && (
                      <a href={`${urlDowload}/${att.Guid}`} download>
                        <FaFilePdf size={30} color="red" />
                        <p title={att.Name}>{att.Name}</p>
                      </a>
                    )}

                    {att && att.AttachmentType === 11 && (
                      <a href={`${urlDowload}/${att.Guid}`} download>
                        <FaFileAlt size={30} color="#333" />
                        <p title={att.Name}>{att.Name}</p>
                      </a>
                    )}

                    {att &&
                      att.AttachmentType !== 0 &&
                      att.AttachmentType !== 1 &&
                      att.AttachmentType !== 10 &&
                      att.AttachmentType !== 11 &&
                      att.AttachmentType !== 20 &&
                      att.AttachmentType !== 100 && (
                        <a href={`${urlDowload}/${att.Guid}`} download>
                          <FaFileAlt size={30} color="#333" />
                          <p title={att.Name}>{att.Name}</p>
                        </a>
                      )}

                    {att && att.AttachmentType === 100 && (
                      <a href={`${urlDowload}/${att.Guid}`} download>
                        <FaFile size={30} color="#333" />
                        <p title={att.Name}>{att.Name}</p>
                      </a>
                    )}
                  </AttachmentFile>
                </React.Fragment>
              );
            }
          })}
        </AttachmentContainer>
      )}
      <Linkify
        componentDecorator={(decoratedHref, decoratedText, key) => (
          <MessageLink
            target="_blank"
            rel="noreferrer"
            href={decoratedHref}
            key={key}
          >
            {decoratedText}
          </MessageLink>
        )}
      >
        <MessageText>
          {message.IsPoll && !isDeleted ? (
            <ViewPoll message={message} userGuid={userGuid} />
          ) : message.IsHtmlMessage && !isDeleted ? (
            <div dangerouslySetInnerHTML={{ __html: text }} />
          ) : (
            text
          )}
        </MessageText>
      </Linkify>
      {!isDeleted && (
        <>
          <BalloonDate>{getStringDate(formatedDate)}</BalloonDate>
          <BalloonInfo>
            {message.Sender?.StaffGuid === userGuid && message.IsRead && (
              <DoneAllIcon className="accent-icon" />
            )}
            {message.Sender?.StaffGuid === userGuid && !message.IsRead && (
              <DoneIcon />
            )}
          </BalloonInfo>
          <BalloonActions>
            <ActionsMessage
              message={message}
              my={message.Sender?.StaffGuid === userGuid}
              setSelectedMessage={setSelectedMessage}
              setSelectedMessageForward={setSelectedMessageForward}
              setOpen={setOpen}
            />
          </BalloonActions>
        </>
      )}
    </Balloon>
  );
};

export { BalloonComponent };
